export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-196x196-ba0d6e1eaeb446166c9f67fd78681b85.png";